import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./css/LandingStyle.css";

const VideoSection = ({
  videoUrls,
  handlePrev,
  handleNext,
  getPositionClass,
}) => {
  return (
    <section className="videos-section">
      <div className="videos-header">
        <span className="section-tag">Product Tour</span>
        <h2 className="section-title">Experience Med-CO in Action</h2>
      </div>

      <div className="modern-carousel-wrapper">
        <button
          className="nav-ctrl prev"
          onClick={handlePrev}
          aria-label="Previous"
        >
          <ChevronLeft />
        </button>

        <div className="carousel-viewport">
          <div className="carousel-track">
            {videoUrls.map((url, index) => {
              const position = getPositionClass(index);
              const isVisible = position !== "hidden";

              return (
                <div key={index} className={`carousel-card ${position}`}>
                  <div className="video-card-inner">
                    {isVisible ? (
                      <iframe
                        className="main-video"
                        src={url}
                        title={`Med-CO Demo ${index}`}
                        frameBorder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <div className="video-placeholder" />
                    )}

                    {position !== "active" && (
                      <div
                        className="card-overlay"
                        onClick={position === "left" ? handlePrev : handleNext}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <button
          className="nav-ctrl next"
          onClick={handleNext}
          aria-label="Next"
        >
          <ChevronRight />
        </button>
      </div>
    </section>
  );
};

export default VideoSection;
